import axios from 'axios';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import store from '../store';
import router from '../router';

const errorCodeText = {
  401: '尚未登入，請先登入',
};

const openErrorDialog = (message) => {
  store.dispatch('error/openErrorDialog', message);
};

const api = process.env.VUE_APP_API;
axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get('token');
    const headers = {
      'content-type': 'application/json',
      Authorization: Cookies.get('token') ? `Bearer ${Cookies.get('token')}` : '',
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const url = config.url.startsWith('http') ? config.url : `${api}/${config.url}`;
    return {
      ...config,
      headers,
      url,
    };
  },
  (error) => Promise.reject(error),
);

// 回應攔截
axios.interceptors.response.use(
  ({ data: response }) => {
    const { status, message } = response;
    if (status === 0) {
      Swal.fire({ title: '操作失敗', icon: 'error', text: message });
    }
    return response;
  },
  (error) => Promise.reject(error),
);

async function Ajax(method = '', url, params) {
  try {
    const result = await axios({
      url,
      method,
      [method.toLowerCase() === 'get' ? 'params' : 'data']: params,
    });
    return result;
  } catch (error) {
    let message = '';
    if (error.response) {
      // http code error
      const code = error.response.status;
      message = errorCodeText[code] || '伺服器錯誤，請通知相關人員';
      if (code === 401) {
        router.push({ name: 'login' });
      }
    } else {
      // 進入 server 後的錯
      message = error.message;
    }
    openErrorDialog(message);
  }
}

export default Ajax;
